'use client'
import React, { useState } from 'react';
import HeroSection from '../HeroSection';
import heroImage from '@/app/assets/images/nest_web_marketing_designer_landing_page_hero_image.png';
interface SupplierHeroSectionProps {
    handleUploadClick: any
}
const SupplierHeroSection: React.FC<SupplierHeroSectionProps> = (props) => {
    const { handleUploadClick } = props;
    const [modalOpen, setModalOpen] = useState(false);
    return (
        <div>
            <HeroSection heroImage={heroImage} modalOpen={modalOpen} setModalOpen={setModalOpen} handleClickCreateDesign={handleUploadClick} buttonText='Add Products' underButtonText='We support most image types, zip files, 3D models, and spreadsheets' />
        </div>
    )
}
export default SupplierHeroSection